<script setup lang="ts">
import { X } from 'lucide-vue-next'

defineProps<{
    title: string
}>()

defineEmits<{
    (e: 'close'): void
}>()
</script>

<template>
    <div class="border-b-[3px] border-b-teal/40 border-l-[3px] border-l-teal/50 bg-teal/[.05]">
        <div class="p-2">
            <div class="bg-white border border-gray-200 rounded-12 overflow-hidden">
                <div class="flex items-center justify-between px-3 py-2 border-b border-gray-200 bg-gray-50">
                    <span class="text-sm font-semibold text-ink">{{ title }}</span>
                    <button
                        type="button"
                        class="w-7 h-7 rounded-6 flex items-center justify-center text-gray-400 hover:text-gray-700 hover:bg-gray-100"
                        @click="$emit('close')"
                    >
                        <X class="w-4 h-4" />
                    </button>
                </div>
                <div class="p-2">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>
